import React from 'react';
import { connect } from 'react-redux';
import {
  Card, CardBody, CardTitle,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import qs from 'qs';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {
  searchEarthquakes as searchEarthquakesAc,
  clearRedirect as clearRedirectAc,
  clearEarthquakeSearch as clearEarthquakeSearchAc,
} from '../../../../../redux/earthquakes/search/earthquakeSearchActions';
import {
  deleteEarthquake as deleteEarthquakeAc,
  getRegions as getRegionsAc,
  clearEarthquakeData as clearEarthquakeDataAc,
  sortData as sortDataAc,
  toggleColumns as toggleColumnsAc,
} from '../../../../../redux/earthquakes/data/earthquakeDataActions';
import { resolveSearchParameters } from '../search/searchParameterNameResolver';
import { SearchParamDisplay } from '../../../../data/SearchParamDisplay';
import { isDataManager } from '../../../../../role/roleUtils';
import { Loading } from '../../../../loadbar/Loading';
import { EarthquakeDataGrid } from './EarthquakeDataGrid';


class EarthquakeContainerUnwrapped extends React.Component {
  constructor(props) {
    super(props);
    this.toggleDescriptionModal = this.toggleDescriptionModal.bind(this);
    this.state = {
      queryParameters: {},
    };
  }

  componentDidMount() {
    document.title = 'NCEI Hazard Earthquake Results';
    const {
      clearEarthquakeData,
      searchEarthquakes,
      clearRedirect,
      searchRedirect,
      getRegions,
      location: { search },
      history,
    } = this.props;
    clearEarthquakeData();
    getRegions({ history });
    let queryParameters = {};
    if (search.length) {
      queryParameters = qs.parse(search.split('?')[1]);
    }
    if (!searchRedirect) {
      searchEarthquakes({ queryParameters, history });
    } else {
      clearRedirect();
    }
    this.setState({ queryParameters });
  }

  componentWillUnmount() {
    const { clearEarthquakeSearch, clearEarthquakeData } = this.props;
    clearEarthquakeSearch();
    clearEarthquakeData();
  }

  toggleDescriptionModal(name) {
    this.setState(state => ({ modals: state.modals.update(name, val => !val) }));
  }

  render() {
    const {
      earthquakes,
      fetched,
      deleting,
      authorities,
      peopleDescriptors,
      damageDescriptors,
      regions,
      sort,
      sortData,
      visibleColumns,
      toggleColumns,
      deleteEarthquake,
      history,
      searchEarthquakes,
    } = this.props;
    const { queryParameters } = this.state;
    const dataManager = isDataManager(authorities);

    if (!fetched) {
      return (<Loading />);
    }

    const sp = resolveSearchParameters({
      params: queryParameters, regions, peopleDescriptors, damageDescriptors,
    });

    return (
      <div className="haz-results-container haz-page-container">

        {Boolean(sp.length) && <SearchParamDisplay messages={sp} />}
        <div className="haz-data-grid-container">
          <div className="haz-data-grid-container">
            <Card>
              <CardBody>
                <div className="doiCitation">
                  <span id="doiReference">
                    <p>
                      <a href="http://dx.doi.org/10.7289/V5TD9V7K" rel="noopener noreferrer" target="_blank" title="Earthquake DOI Information" aria-label="Earthquake DOI Information">Please cite DOI:10.7289/V5TD9V7K</a>
                    </p>
                  </span>
                </div>
                <CardTitle tag="h2">{`Earthquakes - ${earthquakes.size} Results Found`}</CardTitle>
                <EarthquakeDataGrid
                  earthquakes={earthquakes}
                  dataManager={dataManager}
                  sort={sort}
                  sortData={sortData}
                  visibleColumns={visibleColumns}
                  toggleColumns={toggleColumns}
                  searchParams={JSON.stringify(sp)}
                  deleting={deleting}
                  deleteEarthquake={deleteEarthquake}
                  history={history}
                  onDeleteCloseModal={() => searchEarthquakes({ queryParameters, history })}
                />
              </CardBody>
            </Card>
          </div>
        </div>

      </div>
    );
  }
}

EarthquakeContainerUnwrapped.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  fetched: PropTypes.bool.isRequired,
  deleting: PropTypes.bool.isRequired,
  earthquakes: ImmutablePropTypes.list.isRequired,
  searchEarthquakes: PropTypes.func.isRequired,
  clearEarthquakeSearch: PropTypes.func.isRequired,
  deleteEarthquake: PropTypes.func.isRequired,
  history: PropTypes.shape({}).isRequired,
  clearRedirect: PropTypes.func.isRequired,
  searchRedirect: PropTypes.bool.isRequired,
  authorities: ImmutablePropTypes.list.isRequired,
  peopleDescriptors: ImmutablePropTypes.list.isRequired,
  damageDescriptors: ImmutablePropTypes.list.isRequired,
  regions: ImmutablePropTypes.list.isRequired,
  clearEarthquakeData: PropTypes.func.isRequired,
  getRegions: PropTypes.func.isRequired,
  sortData: PropTypes.func.isRequired,
  sort: ImmutablePropTypes.list.isRequired,
  visibleColumns: ImmutablePropTypes.list.isRequired,
  toggleColumns: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  fetched: [
    state.getIn(['earthquakeSearchPage', 'fetched']),
    state.getIn(['earthquakeDataPage', 'fetchedRegions']),
  ].every(v => v),
  deleting: state.getIn(['earthquakeDataPage', 'deleting']),
  earthquakes: state.getIn(['earthquakeSearchPage', 'earthquakes']),
  searchRedirect: state.getIn(['earthquakeSearchPage', 'searchRedirect']),
  damageDescriptors: state.getIn(['effectDescriptors', 'damage']),
  peopleDescriptors: state.getIn(['effectDescriptors', 'people']),
  regions: state.getIn(['earthquakeDataPage', 'regions']),
  sort: state.getIn(['earthquakeSearchPage', 'sort']),
  visibleColumns: state.getIn(['earthquakeDataPage', 'visibleColumns']),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  searchEarthquakes: searchEarthquakesAc,
  clearEarthquakeSearch: clearEarthquakeSearchAc,
  deleteEarthquake: deleteEarthquakeAc,
  clearRedirect: clearRedirectAc,
  getRegions: getRegionsAc,
  clearEarthquakeData: clearEarthquakeDataAc,
  sortData: sortDataAc,
  toggleColumns: toggleColumnsAc,
}, dispatch);


export const EarthquakeContainer = connect(mapStateToProps, mapDispatchToProps)(EarthquakeContainerUnwrapped);
